const HIGHLIGHTED_LABELS = new Set(["Coordinates (decimal)"]);

const renderRemarksValue = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return value.split("\n").map((line, index) => {
    const sourceMatch = line.match(/^Source:\s+(https?:\/\/\S+)$/);
    if (sourceMatch) {
      return (
        <div key={`remarks-line-${index}`}>
          Source:{" "}
          <a href={sourceMatch[1]} target="_blank" rel="noreferrer">
            {sourceMatch[1]}
          </a>
        </div>
      );
    }

    return <div key={`remarks-line-${index}`}>{line}</div>;
  });
};

const renderRows = (rows, comparisonEnabled = false) =>
  rows.map((row) => {
    const [label, value, matchStatus] = row;
    const classes = [];

    if (comparisonEnabled) {
      if (matchStatus === "match") {
        classes.push("resighting-qc-record-row-match");
      } else if (matchStatus === "mismatch") {
        classes.push("resighting-qc-record-row-mismatch");
      }
    } else if (HIGHLIGHTED_LABELS.has(label)) {
      classes.push("resighting-qc-record-row-highlight");
    }

    return (
      <tr key={label} className={classes.join(" ") || undefined}>
        <th>{label}</th>
        <td>
          {label === "Remarks" ? (
            renderRemarksValue(value)
          ) : typeof value === "string" && /^https?:\/\//.test(value) ? (
            <a href={value} target="_blank" rel="noreferrer">
              {value}
            </a>
          ) : (
            value
          )}
        </td>
      </tr>
    );
  });

const DetailsTable = ({ title, rows, comparisonEnabled }) => (
  <div className="resighting-qc-details-grid-item">
    <h3 className="resighting-qc-subsection-title">{title}</h3>
    <table className="resighting-qc-record-table">
      <tbody>{renderRows(rows, comparisonEnabled)}</tbody>
    </table>
  </div>
);

function ResightingAvifaunaRecordDetails({ record }) {
  if (!record?.hasData) {
    return null;
  }

  const comparisonEnabled = record?.comparisonEnabled ?? false;

  return (
    <div className="resighting-qc-details-grid" style={{ marginTop: "1rem" }}>
      {record.ringingRows?.length ? (
        <DetailsTable
          title="Ringing details (Avifauna)"
          rows={record.ringingRows}
          comparisonEnabled={comparisonEnabled}
        />
      ) : null}
      {record.resightingSections?.map((section, index) => (
        <div
          key={`avifauna-resighting-${index}`}
          className="resighting-qc-details-grid"
          style={{ display: "contents" }}
        >
          <DetailsTable
            title={section.title}
            rows={section.rows}
            comparisonEnabled={comparisonEnabled}
          />
        </div>
      ))}
    </div>
  );
}

export default ResightingAvifaunaRecordDetails;
